var _filter, _filter2, _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebnortv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 420",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      margin: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenBg",
    x1: "20%",
    y1: "0%",
    x2: "80%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1a2f5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0f172a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0a0f1e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tvGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60a5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#1a56db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0a1a4a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metalGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#c0c8d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6080aa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bodyGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#111"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodColor: "#000",
    floodOpacity: 0.25
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tvClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.728,
    y: 49.641,
    width: 405.031,
    height: 244.443,
    rx: 6
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "tabClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.668,
    y: 130.294,
    width: 202.472,
    height: 229.645,
    rx: 8
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "phoneClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.875,
    y: 214.023,
    width: 86.474,
    height: 138.484,
    rx: 10
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 154.816,
    y: 38,
    width: 428.855,
    height: 279.364,
    rx: 14,
    fill: "url(#bodyGrad)",
    filter: "url(#shadow)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.729,
    y: 49.64,
    width: 405.03,
    height: 244.443,
    rx: 6,
    fill: "url(#screenBg)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.243,
    cy: 171.862,
    rx: 142.952,
    ry: 87.301,
    fill: "#1a56db",
    opacity: 0.25,
    clipPath: "url(#tvClip)",
    style: {
      fill: "rgb(26, 86, 219)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256.742,
    y: 177.259,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 34,
    fontWeight: 900,
    fill: "url(#metalGrad)",
    filter: "url(#glow)",
    letterSpacing: -1,
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 34,
      fontWeight: 900,
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(1.191264, 0, 0, 1.164016, -58.112873, -19.338554)"
  }, "webnor"), /*#__PURE__*/React.createElement("text", {
    x: 386.928,
    y: 178.389,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 34,
    fontWeight: 900,
    fill: "url(#tvGrad)",
    filter: "url(#glow)",
    fontStyle: "italic",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 34,
      fontWeight: 900,
      fontStyle: "italic",
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(1.191264, 0, 0, 1.164016, -58.112873, -19.338554)"
  }, "TV"), /*#__PURE__*/React.createElement("rect", {
    x: 343.036,
    y: 317.364,
    width: 52.416,
    height: 9.312,
    rx: 4,
    fill: "#222",
    style: {
      fill: "rgb(34, 34, 34)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.593,
    y: 324.348,
    width: 95.301,
    height: 6.984,
    rx: 3,
    fill: "#1a1a1a",
    style: {
      fill: "rgb(26, 26, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.569,
    y: 121.459,
    width: 218.67,
    height: 256.146,
    rx: 14,
    fill: "url(#bodyGrad)",
    filter: "url(#shadow)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.668,
    y: 130.291,
    width: 202.472,
    height: 229.649,
    rx: 8,
    fill: "url(#screenBg)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.904,
    cy: 245.116,
    rx: 80.989,
    ry: 52.995,
    fill: "#1a56db",
    opacity: 0.25,
    clipPath: "url(#tabClip)",
    style: {
      fill: "rgb(26, 86, 219)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 430.404,
    y: 168,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 20,
    fontWeight: 900,
    fill: "url(#metalGrad)",
    filter: "url(#glow)",
    letterSpacing: -0.5,
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 20,
      fontWeight: 900,
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(1.012361, 0, 0, 0.883263, 65.945396, 103.7939)"
  }, "webnor"), /*#__PURE__*/React.createElement("text", {
    x: 507.32,
    y: 168.91,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 20,
    fontWeight: 900,
    fill: "url(#tvGrad)",
    filter: "url(#glow)",
    fontStyle: "italic",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 20,
      fontWeight: 900,
      fontStyle: "italic",
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(1.012361, 0, 0, 0.883263, 65.945396, 103.7939)"
  }, "TV"), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 25,
    r: 4,
    fill: "#333",
    style: {
      fill: "rgb(51, 51, 51)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    transform: "matrix(1.012361, 0, 0, 0.883263, 65.945396, 103.7939)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.697,
    y: 207.429,
    width: 98.831,
    height: 164.858,
    rx: 18,
    fill: "url(#bodyGrad)",
    filter: "url(#shadow)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.874,
    y: 214.024,
    width: 86.476,
    height: 138.482,
    rx: 10,
    fill: "url(#screenBg)",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.038,
    y: 214.024,
    width: 40.15,
    height: 9.232,
    rx: 7,
    fill: "#111",
    style: {
      fill: "rgb(17, 17, 17)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.113,
    cy: 285.243,
    rx: 33.972,
    ry: 23.74,
    fill: "#1a56db",
    opacity: 0.25,
    clipPath: "url(#phoneClip)",
    style: {
      fill: "rgb(26, 86, 219)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 46.096,
    y: 176.074,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "url(#metalGrad)",
    filter: "url(#glow)",
    letterSpacing: -0.5,
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 11,
      fontWeight: 900,
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(0.772114, 0, 0, 0.659435, 175.461472, 171.771332)"
  }, "webnor"), /*#__PURE__*/React.createElement("text", {
    x: 86.709,
    y: 176.074,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "url(#tvGrad)",
    filter: "url(#glow)",
    fontStyle: "italic",
    style: {
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 11,
      fontWeight: 900,
      fontStyle: "italic",
      textAnchor: "start",
      dominantBaseline: "auto",
      whiteSpace: "pre"
    },
    transform: "matrix(0.772114, 0, 0, 0.659435, 175.461472, 171.771332)"
  }, "TV"), /*#__PURE__*/React.createElement("rect", {
    x: 219.671,
    y: 344.591,
    width: 30.885,
    height: 1.979,
    rx: 2,
    fill: "#333",
    style: {
      fill: "rgb(51, 51, 51)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebnortv);
export default __webpack_public_path__ + "static/media/webnortv.7c941f184ce0e1e395e04321e9b33bd6.svg";
export { ForwardRef as ReactComponent };